export const formatBreadcrumbItems = (breadcrumbItems, type, config) => {
    let storeLanguage;

    if (config) {
        storeLanguage = config.language;
    }

    const getBreadcrumbData = (item) => {
        let href;
        let text;

        if (item.languageContext?.[storeLanguage]) {
            href = item.languageContext[storeLanguage].url;
            text = item.languageContext[storeLanguage].name;
        } else {
            href = item.url;
            text = item.name;
        }

        return [href, text];
    };

    return (
        Array.isArray(breadcrumbItems)
            // eslint-disable-next-line max-len
            ? breadcrumbItems.map(item => ({ type, href: getBreadcrumbData(item)[0], text: getBreadcrumbData(item)[1] }))
            : []);
};
